import styled from 'styled-components';
import { Box, Card } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

export const SearchContainer = styled(Box)`
  width: 100%;
  height: ${(props) => (props.primary === 'true' ? null : '200px')};
  display: flex;
  flex-direction: ${(props) => (props.primary === 'true' ? 'column' : 'row-reverse')};
  justify-content: space-between;
  transition: all 0.5s ease-in-out;
  align-items: ${(props) => (props.primary === 'true' ? 'unset' : 'center')};
`;
export const IconsContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  margin: 10px;
`;

export const Button = styled.button`
  width: ${(props) => (props.primary === 'true' ? '80px' : '50px')};
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 55px;
  letter-spacing: 1px;
  margin: 10px 5px;
  &:hover {
    background-color: #FFA555;
    border-color: #fff;
  }
}
`;
export const FormContainer = styled(Box)`
  transition: all 0.5s ease-in-out;
  width: ${(props) => (props.primary === 'true' ? 'auto' : '55%')};
  display: flex;
  flex-direction: ${(props) => (props.primary === 'true' ? 'column' : 'row')};
  align-items: center;
  margin: 0px;
`;

export const Search = styled.input`
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: 1px solid black;
  background-color: transparent;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  font-size: 16px;
  padding: 0px 40px;
  margin:${(props) => (props.primary === 'true' ? '50px 0px 20px 0px' : '0px 5px')} 
`;
export const InputWrapper = styled(Box)`
  width: ${(props) => (props.primary === 'true' ? '100%' : '100%')};
  position: relative;
  display: flex;
  align-items: center;
`;
export const IconInput = styled(SearchOutlined)`
  transition: all 0.5s ease-in-out;
  color: #191919;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 12px;
  top: 55%;
  transform: translateY(-50%);
`;
export const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
export const Img = styled.img`
  top: 0;
  width: 300px;
  margin: 10px 0px;
`;

export const CardContainer = styled(Card)`
  height: ${(props) => (props.primary === 'true' ? null : '160px')};
  display: ${(props) => (props.primary === 'true' ? 'block' : 'flex')};
  align-items: ${(props) => (props.primary === 'true' ? 'unset' : 'center')};
  &: MuiPaper-root {
    transition: all 0.5s ease-in-out;
  }
`;

const styles = {
  containerCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cards: {
    margin: '20px 0px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  break: {
    width: '80%',
    height: '2px',
    margin: '20px 0px',
    backgroundColor: 'black',
  },
  errorMsg: {
    margin: '20px 0px',
    color: '#ca2f23',
    fontFamily: 'Nunito, sans-serif',
  },
};

export const useStyles = makeStyles(styles);
